module.exports = __webpack_public_path__ + "img/1442166036.89492ea6.jpg";